import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import css from '../css/notification-icon.m.css';
const factory = create({ theme }).properties();
export const NotificationIcon = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { isSpeedDialNotification = false } = properties();
    return v('div', {
        classes: [isSpeedDialNotification ? themeCss.speedDialNotificationIcon : themeCss.menuItemNotificationIcon],
        xqa: 'has-menu-item-notification'
    }, [
        v('span', { classes: ['fa-stack'] }, [
            v('i', { classes: ['fa-stack-1x', 'fas', 'fa-star', themeCss.notificationForeground] })
        ])
    ]);
});
